import { render, staticRenderFns } from "./QuizStartScreenForm.vue?vue&type=template&id=30dda9ac&"
import script from "./QuizStartScreenForm.vue?vue&type=script&lang=ts&"
export * from "./QuizStartScreenForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports